import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import {findDOMNode} from 'react-dom';

function ucFirst(str) {
    return str[0].toUpperCase() + str.substring(1);
}

const EVENTS = [
    'focusin', 'focusout', 'click', 'dblclick', 'mousedown', 'mouseup',
    'mousemove', 'mouseover', 'beforepaste', 'paste', 'cut', 'copy',
    'selectionchange', 'mouseout', 'mouseenter', 'mouseleave', 'keydown',
    'keypress', 'keyup', 'contextmenu', 'dragend', 'dragover', 'draggesture',
    'dragdrop', 'drop', 'drag', 'BeforeRenderUI', 'SetAttrib', 'PreInit',
    'PostRender', 'init', 'deactivate', 'activate', 'NodeChange',
    'BeforeExecCommand', 'ExecCommand', 'show', 'hide', 'ProgressState',
    'LoadContent', 'SaveContent', 'BeforeSetContent', 'SetContent',
    'BeforeGetContent', 'GetContent', 'VisualAid', 'remove', 'submit', 'reset',
    'BeforeAddUndo', 'AddUndo', 'change', 'undo', 'redo', 'ClearUndos',
    'ObjectSelected', 'ObjectResizeStart', 'ObjectResized', 'PreProcess',
    'PostProcess', 'focus', 'blur', 'dirty',
];

const HANDLER_NAMES = EVENTS.map((event) => {
    return 'on' + ucFirst(event);
});

export default class TinyMCE extends React.Component {
    static propTypes = {
        config: PropTypes.object,
        content: PropTypes.string,
        id: PropTypes.string,
        className: PropTypes.string,
        style: PropTypes.object,
    }

    static defaultProps = {
        config: {},
        content: '',
    }

    componentWillMount() {
        this.id = this.id || this.props.id || window.uuidv4();
    }

    componentDidMount() {
        const config = _.clone(this.props.config);
        this._init(config);
    }

    componentWillReceiveProps(nextProps) {
        const editor = window.tinymce.EditorManager.get(this.id);
        if (!_.isEqual(this.props.id, nextProps.id)) {
            this.id = nextProps.id;
        }
        if (!_.isEqual(this.props.config, nextProps.config)) {
            this._init(nextProps.config, nextProps.content);
        }
        if (!_.isEqual(this.props.style, nextProps.style)) {
            _.map(nextProps.style, (value, key) => editor.bodyElement.style[key] = value);
        }
        if (!_.isEqual(this.props.config, nextProps.config) || !_.isEqual(this.props.id, nextProps.id)) {
            this._init(_.clone(nextProps.config), nextProps.content);
            return;
        }

        if (!_.isEqual(this.props.content, nextProps.content)) {
            editor.setContent(nextProps.content);

            editor.selection.select(editor.getBody(), true);
            editor.selection.collapse(false);
        }
    }

    shouldComponentUpdate(nextProps) {
        return !_.isEqual(this.props.config, nextProps.config);
    }

    componentWillUnmount() {
        this._remove();
    }

    render() {
        return this.props.config.inline ? (
            <div
                id={this.id}
                className={this.props.className}
                style={this.props.style}
                dangerouslySetInnerHTML={{__html: this.props.content}}
            />
        ) : (
            <textarea
                id={this.id}
                className={this.props.className}
                style={this.props.style}
                defaultValue={this.props.content}
            />
        );
    }

    _init(config, content) {
        if (this._isInit) {
            this._remove();
        }

        findDOMNode(this).style.hidden = 'hidden';

        const setupCallback = config.setup;
        const hasSetupCallback = (typeof setupCallback === 'function');

        config.selector = '#' + this.id;
        config.setup = (editor) => {
            EVENTS.forEach((event, index) => {
                const handler = this.props[HANDLER_NAMES[index]];
                if (typeof handler !== 'function') return;
                editor.on(event, (e) => {
                    handler(e, editor);
                });
            });
            if (content) {
                editor.on('init', () => {
                    this._initialized = true;
                    editor.setContent(content);
                });
            }
            if (hasSetupCallback) {
                setupCallback(editor);
            }
        };

        window.tinymce.init(config);

        findDOMNode(this).style.hidden = '';

        this._isInit = true;
    }

    _remove() {
        window.tinymce.EditorManager.execCommand('mceRemoveEditor', true, this.id);
        this._isInit = false;
    }
}

// HANDLER_NAMES.forEach((name) => {
//     console.log("forEach:"+name)
//     TinyMCE.propTypes[name] = PropTypes.func;
// });
